import { Component, OnInit, Input, ChangeDetectorRef, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../user/_services/authentication.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { User } from '../../user/_models/user.model';
import { Modules, UserType, PSIOperators } from '../../_common/_enum/module.enum';
import { SearchCriteria } from '../../search/search/_model/search-criteria';
import { HeaderData } from 'src/app/_models/header-data';
import { CommonService } from 'src/app/_services/common.service';
import { PRODUCT_CONFIG } from 'src/app/_common/product-config';
import { EllipsisPipe } from 'src/app/_pipes/ellipsis.pipe';
import { ModalService } from 'src/app/_services/modal.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isLoggedIn$: Observable<boolean>; 
  currentUser:User;
  showMenu: Boolean;
  searchFilter: SearchCriteria;
  private killLogoutOnDestroy;

  private productConfig = PRODUCT_CONFIG;
  listHeader:string;

  searchTerm: string;
  searchPlaceholder: string = "Search...";
  headerData: HeaderData;

  private banner: any;

  @Input() onDashboard: boolean;
  @ViewChild("announcementModal", {static: false}) announcementModal;

  constructor(private authenticationService: AuthenticationService, private router: Router, private commonService: CommonService, private changeDetectorRef : ChangeDetectorRef, private modalService: ModalService) { }

  ngOnInit() {
    let psiData = this.commonService.getData();
    /*if(psiData.currentUser.userType == UserType.ProSight){
      this.impersonatedBy = this.commonService.viewingAs;
    }*/
    this.searchTerm = (psiData.search && psiData.search.searchTerm)?psiData.search.searchTerm:"";
    this.fetchLoggedInUser();
    
    this.banner = (environment.banner) ? JSON.parse(environment.banner) : null;

    this.showMenu = false;
    this.searchFilter = new SearchCriteria();
    this.headerData = this.getHeaderData();
    //list button header
    if(this.commonService.checkPermission(Modules.AccountList)){
      this.listHeader = "Account";
    }
    else if(this.commonService.checkPermission(Modules.PolicyList)){
      this.listHeader = "Policy";
    }
    else if(this.commonService.checkPermission(Modules.ClaimList)){
      this.listHeader = "Claim";
    }
    //search placeholder text
    if(this.commonService.checkPermission(Modules.PolicySearch)){
      if(this.commonService.checkPermission(Modules.ClaimSearch)){
        this.searchPlaceholder = "Search Accounts, Policies, or Claims...";
      }
      else{
        this.searchPlaceholder = "Search Accounts or Policies...";
      }
    }
    else if(this.commonService.checkPermission(Modules.ClaimSearch)){
      this.searchPlaceholder="Search Claims..."
    }

    this.router.events.subscribe((event) =>{
      //this.commonService.header = new HeaderData();
      if(event && event['url'] && (!(event['url'].includes('/search')) && !(event['url'].includes('/login')))){
        //let psiData = this.commonService.getData();
        //psiData.search = {};
        //this.commonService.storeData(psiData);
        this.searchTerm = "";
      }
    });
  }

  getDescription(_description, _isFilterNeeded = true) {
    if(_isFilterNeeded){
      let pipe = new EllipsisPipe();
      return pipe.transform(_description, PRODUCT_CONFIG.LongCommonTextEllipsis);
    } else {
      return _description;
    }
  }

  ngAfterViewChecked() {
    let headerData = this.getHeaderData();
    if(headerData != this.headerData){
      this.headerData = headerData;
      this.changeDetectorRef.detectChanges();
    }
  }

  private getHeaderData(){
    return this.commonService.header;
  }

  getHeaderDataForAnimation(){
    return this.headerData? this.headerData: "none";
  }

  fetchLoggedInUser(){
    this.currentUser = this.authenticationService.currentUser;
  }

  onLogout(){
    this.showMenu = false;
    if(this.killLogoutOnDestroy){
      this.killLogoutOnDestroy.unsubscribe();
    }
    this.killLogoutOnDestroy = this.authenticationService.logout().subscribe(data => {
      this.router.navigateByUrl("/login");
    });
  }
  onUserProfile(){
    this.showMenu = false;
    this.router.navigateByUrl("/profile");
    this.headerData.pageTitle = 'User Profile';
    this.authenticationService.authenticationScreen = false;
  }
  onFAQs(){
    this.showMenu = false;
    this.router.navigateByUrl("/faq");
  }

  onSupport() {
    this.showMenu = false;
    window.open('https://support.prosightspecialty.com/incidents/new.portal', '_blank');
  }
  get ModuleEnum(){
    return Modules;
  }
  get PSIOperatorsEnum(){
    return PSIOperators;
  }

  getNewBusinessURL(modules){
    if(modules && modules.length > 0){
      for(let i = 0; i < modules.length; i++){
        let moduleName = modules[i];
        let module = this.authenticationService.getModule(moduleName);
        if(module){
          return "newbusiness/"+module.link.toLowerCase();
        }
      }
    }
  }
  
  onSearch(){
    this.showMenu = false;
    if(this.searchTerm){
      let psiData = JSON.parse(sessionStorage.getItem('psiData'));
      psiData.search = {"searchTerm" : this.searchTerm};
      this.commonService.storeData(psiData);
      
      if(this.router.url == "/search"){        
        this.router.navigate(['/search/'+Math.random()], {skipLocationChange:true});
      }else{
        this.router.navigate(['/search']);
      }
    }
  }

  openLearnMore(){
    this.modalService.openModal(this.announcementModal, false, 'light-blue-backdrop', 'static', 'coming-soon-modal');
  }
}
